/**
 * Cashier Payment View
 */

define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var url = require('util/url.util');
    var PortletView = require('modules/portlet/portlet.view');
    var storage = require('util/storage.util');
    var cashierUtil = require('modules/cashier/cashier.util');
    var user = require('user');
    var _ = require('underscore');

    require('widgets/accordion.widget');

    var CashierPaymentView = PortletView.extend({

        /**
         * Type of View for method
         * @type {Backbone.View}
         */
        MethodView: null,

        /**
         * Type of Collection for methods
         * @type {Backbone.Collection}
         */
        MethodsCollection: null,

        /**
         * State of payment methods getting
         * @type {Deferred}
         */
        state: null,

        accessRules: {
            allow: ['user']
        },

        events: _.extend({}, PortletView.prototype.events, {
            'tap .fn-card-add': 'handleAddCardTap'
        }),

        template: function() {
            // should return html template
        },

        initialize: function(options) {

            this.options = options;

            this.cashierType = this.options.config.cashierType || 'DEPOSIT';

            this.methods = new this.MethodsCollection([], this._getMethodsOptions());

            this.attachWidget(this.$el.accordion());
        },

        subscribe: function() {
            this.listenTo(core, 'cashier:refresh', this.updatePortlet.bind(this));
        },

        _getMethodsOptions: function() {
            var options = {
                config: this.options.config,
                paymentMethodsOrder: this.options.config.paymentMethodsOrder
            };

            if (this.cashierType.toLowerCase() === 'deposit') {
                options.suggestDepositAmounts = this.options.config.suggestDepositAmounts;
            }

            return options;
        },

        render: function() {
            var tmplOptions = _.extend(
                {}, this.options.config,
                { addCardViaVC: this.isVisaCheckoutEnabled() }
            );
            this.$el.html(this.template(tmplOptions));

            this.state = this.methods.fetch()
                .done(this.renderPaymentAccounts.bind(this))
                .fail(this.renderResponseError.bind(this))
                .always(() => cashierUtil.notifyTransactionStatus());

            return this;
        },

        portletDidMount: function() {
            // continue register for fast registered players
            if (user.isFastRegistered()) {
                return user.continueRegistration();
            }
        },

        handleAddCardTap: function(e) {
            var dataset = e.currentTarget.dataset;

            this.goToAddCard(dataset.url, 'visaCheckout' in dataset);
        },

        goToAddCard: function(path, isVisaCheckout) {
            var pathToAddCard = path || '/add-card';
            var searchParams = new URLSearchParams();

            searchParams.append('back_url', url.pathname + url.search);
            isVisaCheckout && searchParams.append('visaCheckout', '1');
            core.navigate(pathToAddCard + '?' + searchParams.toString());
        },

        renderPaymentAccounts: function() {
            var methodsFragment = document.createDocumentFragment();

            storage.session.removeItem('lastAddedPayment');

            if (this.methods.length === 0) {
                return this.renderEmpty();
            }

            this.methods.forEach(function(method) {
                var methodView = new this.MethodView({ model: method }).render();

                this.childViews.push(methodView);
                methodsFragment.appendChild(methodView.el);
            }, this);

            this.$('.fn-payment-accounts').html(methodsFragment);
        },

        renderEmpty: function() {
            var emptyMessage = this.translate('playtech.mobile.system.mobile-cashier.cashier-empty.'
                + this.cashierType.toLowerCase());

            this.renderErrorMessage('empty', emptyMessage);
        },

        updatePortlet: function(args) {
            const viewsToClose = this.childViews.slice(0);

            this.state = this.methods.fetch({ reset: true })
                .done((response) => {
                    this.renderPaymentAccounts(response);

                    const { id } = args || {};

                    if (id) {
                        this.childViews.forEach((childView) => {
                            if (childView.model.id === id) {
                                childView.$('.fn-accordion-target').trigger('tap');
                            }
                        });
                    }

                    _.invoke(viewsToClose, 'close');
                })
                .fail(this.renderResponseError.bind(this));
        },

        /**
         * @deprecated since 17.1.0. Use `cashierUtil.getNonPekoErrorMessage()` instead
         */
        getNonPekoErrorMessage: function() {
            return cashierUtil.getNonPekoErrorMessage.apply(this, arguments);
        },

        renderResponseError: function(response) {
            var errorMessage = cashierUtil.getErrorMessage(response)
                || cashierUtil.getNonPekoErrorMessageGpm(response, this.cashierType.toLowerCase());

            this.renderErrorMessage('error', errorMessage);
        },

        renderErrorMessage: function(template, message) {
            this.$('.fn-payment-accounts').html(this.tmpl('cashier.' + template, {
                message: message
            }));
        },

        isVisaCheckoutEnabled: function() {
            var paymentsConfig = user.get('paymentsConfig') || {};

            return paymentsConfig.tokenProvider === 'safecharge'
                && paymentsConfig.enableVisaCheckout;
        },

        close: function() {
            PortletView.prototype.close.apply(this, arguments);
        }
    });

    module.exports = CashierPaymentView;

});
